import { Password } from '@mui/icons-material';
import { transparentize } from 'polished';
import styled from 'styled-components';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 800px;

  ${({ theme }) => theme.breakpoints.up('xs')} {
    padding: 15px;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: 0 35px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 0 98px;
  }

  .icon-container {
    max-width: 83px;
    padding: 24px;
    background-color: ${({ theme }) =>
      transparentize(0.9, theme.palette.primary.main)};
    border-radius: 8px;
    margin-bottom: 24px;
  }
`;

export const ForgotPasswordContainer = styled.section`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: flex-start;
  width: 100%;
  margin-top: 40px;
`;

export const FormContainer = styled.form`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 50px;
`;

export const FormGroup = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 40px;
`;

export const VerifyEmailContainer = styled.section`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: flex-start;
  width: 100%;
  margin-top: 40px;
`;

export const PasswordIcon = styled(Password)`
  height: 30px;
`;
